const buttonStyle = {padding: '14px', marginRight: '10px'}

export {buttonStyle}
